import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"

const adReportListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, ad) => <>{ad?.id}</>,
    },
    {
      text: "Name",
      dataField: "name",
      formatter: (cellContent, ad) => (
        <>{ad?.guest_id ? `Visitor ${ad?.guest_id}` : ad?.name || ""}</>
      ),
    },
    {
      text: "Email",
      dataField: "email",
      formatter: (cellContent, ad) => <>{ad.email ? ad.email : "-"}</>,
    },
    {
      text: "URL",
      dataField: "clicked_url",
      formatter: (cellContent, ad) => (
        <>{ad?.clicked_url ? ad?.clicked_url : "-"}</>
      ),
    },
    {
      text: "# of Clicks",
      dataField: "total_clicks",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, ad) => (
        <>{ad?.total_clicks ? ad?.total_clicks : "-"}</>
      ),
    },
  ]
}

export default adReportListColumns
